import React from "react";
import Tippy from "@tippyjs/react";
import ReactHtmlParser from "react-html-parser";

const TippyIcon = props => {
	const hoverCapable =
		typeof window !== "undefined" &&
		window.matchMedia &&
		window.matchMedia("(hover: hover) and (pointer: fine)").matches;

	return (
		<>
			{props.content ? (
				<Tippy
					animation="fade"
					theme="custom"
					disabled={!props.content || props.content === "" || !hoverCapable}
					content={
						String(props.content).match(/(<([^>]+)>)/i)
							? ReactHtmlParser(props.content)
							: props.content
					}
					placement={props.placement ? props.placement : "bottom"}
					popperOptions={{ modifiers: [{ name: "flip", enabled: false }] }}
					arrow={true}
					style={{ zIndex: 99 }}
					className={`custom-tippy ${props.className ? props.className : ""}`}
				>
					{props.children}
				</Tippy>
			) : (
				props.children
			)}
		</>
	);
};

export default TippyIcon;
